import gql from 'graphql-tag'

export const PROFILE_TOKEN = gql`
  query ProfileToken {
    getProfileToken
  }
`
